/** Add server guidance only while composing the clinician's editable preview. */
export function withApprovalMessageNotice(message: string, notice?: string) {
  const guidance = notice?.trim();
  const normalizeWhitespace = (text: string) => text.replace(/\s+/g, " ").trim();
  if (
    !guidance ||
    normalizeWhitespace(message).includes(normalizeWhitespace(guidance))
  ) {
    return message;
  }
  return [message.trimEnd(), guidance].filter(Boolean).join("\n\n");
}
